import { LoadingOverlay } from "@mantine/core";
import TagManager from "react-gtm-module";
import type React from "react";
import { useEffect } from "react";
import { Navigate, Outlet } from "react-router";

import { useAppConfig } from "~/config/AppConfig";
import { InitAuthenticated } from "~/ui/InitAuthenticated";
import { Layout } from "~/ui/layout/Layout";

import { RoutesEnum } from "../RoutesEnum";
import { useIsAuthenticated } from "./useIsAuthenticated";
import { useIsAuthorized } from "./useIsAuthorized";

const AuthRoute: React.FC = () => {
  const appConfig = useAppConfig();

  const { isAuthenticated, isLoading } = useIsAuthenticated();
  const { isAuthorized, isLoading: isLoadingAuthorized } = useIsAuthorized();
  useEffect(() => {
    if (appConfig.tracking.gtmId) {
      TagManager.initialize({ gtmId: appConfig.tracking.gtmId });
    }
  }, [appConfig.tracking.gtmId]);

  if ((isLoading && !isAuthenticated) || (isLoadingAuthorized && !isAuthorized)) {
    return <LoadingOverlay visible />;
  }

  if (!isAuthenticated) {
    return <Navigate to={RoutesEnum.LOGIN} replace />;
  }

  if (!isAuthorized) {
    return <Navigate to={RoutesEnum.NO_ACCESS} replace />;
  }

  return (
    <Layout>
      <InitAuthenticated />
      <Outlet />
    </Layout>
  );
};
export { AuthRoute };
